import { DialogActions, DialogContent } from '@mui/material';
import { useState } from 'react';
import BaseDialog from '../../../common/BaseDialog/BaseDialog';
import BaseDialogHeading from '../../../common/BaseDialog/BaseDialogHeading';
import { classes } from '../../../../lib/utils/cssUtils';
import TableManager from '../TableManager/TableManager';
import { baseSearchFn } from '../TableManager/TableManager.utils';
import { COMMON_LABELS } from '../../../../lib/constants/labelKeys';
import { Label } from '../../../common/Label/Label';
import RefreshLoader from '../../../common/RefreshLoader/RefreshLoader';
import Button from '../../../common/Button/Button';
import { TableManagerProps } from '../TableManager/TableManager.types';
import styles from './BaseReportDialog.module.scss';

export type BaseReportDialogProps = {
  onClose: () => void;
  dialogTitle: string;
  action?: () => Promise<void>;
  actionLabelKey: string;
} & TableManagerProps;

const BaseReportDialog = ({ onClose, dialogTitle, action, actionLabelKey, ...rest }: BaseReportDialogProps) => {
  const [isActionPending, setIsActionPending] = useState(false);

  const handleSubmit = async () => {
    setIsActionPending(true);

    try {
      await action?.();
    } finally {
      setIsActionPending(false);
    }
  };

  return (
    <BaseDialog open onClose={onClose}>
      <BaseDialogHeading closeButtonProps={{ onClick: onClose }}>{dialogTitle}</BaseDialogHeading>
      <DialogContent className={classes(styles.scrollableChildren, styles.tableDialogContent)}>
        <TableManager
          className={styles.scrollableChildren}
          searchBy={baseSearchFn(0)}
          customClasses={{
            headContainer: classes(styles.dialogTableHeading, styles.headingContainer),
            wrapper: styles.scrollableChildren,
            refreshLoaderContainer: classes(styles.scrollableChildren, styles.tableRefreshLoaderContainer),
          }}
          {...rest}
        />
      </DialogContent>
      <DialogActions className={styles.tableDialogActions}>
        <Button onClick={onClose} variant="outlined" className={styles.dialogTableActionButton}>
          <Label name={COMMON_LABELS.DIALOG.CANCEL} />
        </Button>
        {!!action && (
          <Button onClick={handleSubmit} className={styles.dialogTableActionButton} disabled={isActionPending}>
            {isActionPending && <RefreshLoader />}
            <Label name={actionLabelKey} />
          </Button>
        )}
      </DialogActions>
    </BaseDialog>
  );
};

export default BaseReportDialog;
